module.exports = __webpack_public_path__ + "static/media/baseMeme6thumb.15fe5db2.jpg";